import { ConnectedRouter } from 'connected-react-router';
import { stitch } from 'keo';
import { Route, Switch } from 'react-router';
import { http, httpConfig } from 'utils/http';
import { Provider } from 'react-redux';
import axiosMiddleware from 'redux-axios-middleware';
import { createLogger } from 'redux-logger';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import PropTypes from 'prop-types';
import r from 'render-dom';
import Loadable from 'react-loadable';
import thunk from 'redux-thunk';

import Auth from 'components/public/Auth';
import FiveOhThree from 'components/public/FiveOhThree';
import FourOhFour from 'components/public/FourOhFour';
import Login from 'components/public/Login';
import Logout from 'components/public/Logout';
import { AlertContainer } from 'components/shared/Alert';
import Navigation from 'components/public/Navigation';
import Promote from 'components/public/Promote';
import Reset from 'components/public/Reset';
import SignUp from 'components/public/SignUp';
import Toast from 'components/public/Toast';
import Loading from 'components/ui/Loading';
import createStore from 'redux/createStore';
import history from 'utils/history';

import muiTheme from './theme';

const propTypes = {
    children: PropTypes.node,
    history: PropTypes.object,
    location: PropTypes.object,
};

const middleware = [
    axiosMiddleware(http, httpConfig),
    thunk,
];

if (process.env.NODE_ENV === 'development') {
    middleware.push(createLogger());
}

export const store = createStore(middleware);

const style = { container: { minHeight: '100vh' } };

const App = Loadable({
    loader: () => import('./components/App'),
    loading: Loading,
});

const render = () => (
    r(Provider, { store }, [
        r(ConnectedRouter, { history }, [
            r(MuiThemeProvider, { muiTheme }, [
                r.div({ style: style.container }, [
                    r(Route, { component: Navigation, path: '/' }),
                    r(AlertContainer, { alertComponent: Toast }),
                    r(Switch, [
                        r(Route, { component: Auth, path: '/confirm' }),
                        r(Route, { component: FiveOhThree, path: '/maintenance' }),
                        r(Route, { component: FourOhFour, path: '/404' }),
                        r(Route, { component: Reset, path: '/reset' }),
                        r(Route, { component: SignUp, path: '/signup' }),
                        r(Route, { component: Login, path: '/login' }),
                        r(Route, { component: Logout, path: '/logout' }),
                        r(Route, { component: Promote, path: '/promote' }),
                        r(Route, { component: App, path: '/' }),
                    ]),
                ]),
            ]),
        ]),
    ])
);

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/router.js